import { Injectable } from '@angular/core';
import { AwsSignerService } from '../../services/aws-signer/aws-signer.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Encoder } from '../../utils/encoder';
import { CognitoService } from '../../services/cognito/cognito.service';

@Injectable()
export class ApacDetailService {

  constructor(private awsSignerService: AwsSignerService,
    private cognitoService: CognitoService,
    private http: HttpClient, ) { }
  private getUrl() {
    return `${localStorage.getItem('region-api')}/v1/datamart/manage/volumes`;
  }

  getVolumesList() {
    let url = this.getUrl();

    const awsHeaders = this.awsSignerService.getAwsHeader(url, 'GET');

    const headerParams = {
      'Content-Type': 'application/json',
      'Authorization': awsHeaders['Authorization'],
      'X-Amz-Date': awsHeaders['X-Amz-Date'],
      'x-amz-security-token': awsHeaders['x-amz-security-token'],
      'x-api-key': environment.cesAPI.apiKey,
    };

    const httpOptions = {
      headers: new HttpHeaders(headerParams)
    };

    return this.http.get(url, httpOptions);
  }

  getVolumesDetail(params) {
    const month = Encoder.encode(params.month);
    const awsHeaders = this.awsSignerService.getAwsHeader(`${this.getUrl()}/${month}?memberType=${params.type}`, 'GET');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-amz-security-token': awsHeaders['x-amz-security-token'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    return this.http.get(`${this.getUrl()}/${month}?memberType=${params.type}`, httpOptions);
  }

  refreshAction(action) {

    // const jwtToken = this.cognitoService.getJwtToken();
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': jwtToken,
    //     'x-api-key': environment.cesAPI.apiKey
    //   })
    // };
    const awsHeaders = this.awsSignerService.getAwsHeader(this.getUrl(), 'POST', action);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-amz-security-token': awsHeaders['x-amz-security-token'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };
    return this.http.post(`${this.getUrl()} `, action, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/apac-detail/apac-detail.service.ts